import { useEffect, useRef } from 'react';

export default function useScrollToAnchor(anchorId: string) {
  const hasScrolled = useRef(false);

  useEffect(() => {
    // Only scroll if we haven't scrolled yet and we're on the FAQ section
    if (!hasScrolled.current && window.location.hash === `#${anchorId}`) {
      // Small delay to ensure the component is fully rendered (workaround for pages with loading states)
      setTimeout(() => {
        const element = document.getElementById(anchorId);
        if (element) {
          const navbarHeight = 80; // Offset to match the navbar height
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - navbarHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
          hasScrolled.current = true;
        }
      }, 100);
    }
  }, [anchorId]);
}
